export const SUGGESTED_TEMPLATE_NOTICE_VIEW_EVENT = 'petition_update_suggested_template_banner_view';
export const SUGGESTED_TEMPLATE_NOTICE_CLICK_EVENT = 'petition_update_use_suggested_template_link_click';
export const SUGGESTED_TEMPLATE_NOTICE = 'share_ask';
export const UPDATE_FORM_VEW_EVENT = 'petition_update_composer_view';
export const MAX_TITLE_LENGTH = 100;
export const TITLE_INPUT_FOCUS_EVENT = 'petition_update_composer_title_input_focus';
export const DESCRIPTION_TEXT_AREA_FOCUS_EVENT = 'petition_update_composer_description_input_focus';
export const DESCRIPTION_TEXT_AREA_PREVIEW_CLOSE_EVENT = 'petition_update_embedded_media_close';
export const DESCRIPTION_TEXT_AREA_PREVIEW_FETCH_ERROR_EVENT = 'petition_update_embedded_media_view_error';
export const DESCRIPTION_TEXT_AREA_PREVIEW_FETCH_SUCCESS_EVENT = 'petition_update_embedded_media_view_success';
export const IMAGE_UPLOAD_ON_FILE_ADDED_EVENT = 'petition_update_add_image';
export const PREVIEW_OPEN_EVENT = 'petition_update_preview_open';
export const PREVIEW_CLOSE_EVENT = 'petition_update_preview_close';
export const PREVIEW_CHARACTER_LIMIT = 400;
export const END_OF_TRUNCATION_NOISE = /(?:\p{Separator}|\p{Punctuation}|<)+$/u;
export const FORM_SUBMIT_EVENT = 'petition_update_submit';
export const FORM_SUBMIT_SUCCESS_EVENT = 'petition_update_create';
export const FORM_SUBMIT_ERROR_EVENT = 'petition_update_post_error';
